import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
  Input,
  Button,
  Spin,
  Row,
  Col,
  Modal,
  message,
} from 'antd';

import {
  SearchOutlined,
  DeleteOutlined,
  ArrowLeftOutlined,
  PlusOutlined,
} from '@ant-design/icons';

import { onError } from 'utils/handlers';
import FormSubmitControls from 'components/FormSubmitCustomControls';
import Table from 'components/Table';
import {
  getScianCatalogo,
  // getSubScianCatalogo,
} from 'api/empresas/';
// import Select from 'components/Select';

const BusquedaAvanzadaSCIAN = ({
  visible,
  setVisible,
  callback,
  dataExterno,
  setDataExterno,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  // const [subClase, setSubClase] = useState([]);

  const onCancel = () => {
    setVisible(false);
    setData([]);
    if (setDataExterno) {
      setDataExterno([]);
    }
    setSelectedRowKeys([]);
    form.resetFields();
  };

  const handleSearch = async () => {
    try {
      setLoading(true);
      await form.validateFields();
      setSelectedRowKeys([]);
      const params = form.getFieldsValue();
      const keys = Object.keys(params);
      const validProps = keys.filter((prop) => params[prop]);
      if (validProps.length) {
        const response = await getScianCatalogo({ ...params });
        if (response?.results?.length) {
          setData(response.results);
        } else {
          message.warn('No se encontró actividad.');
          setData([]);
        }
      } else {
        message.warn('Debe ingresar al menos un campo.');
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const onFinishSearch = async (record) => {
    callback(record);
    onCancel();
  };

  useEffect(() => {
    setData(dataExterno);
    // const _subClase = await getSubScianCatalogo();
    // setSubClase(_subClase);
  }, [dataExterno]);

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const add = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      const match = data.find((e) => e.id === key);
      onFinishSearch(match);
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };
  const controls = [
    {
      text: 'Regresar',
      icon: <ArrowLeftOutlined />,
      onClick: () => onCancel(),
    },
    {
      text: 'Limpiar',
      icon: <DeleteOutlined />,
      onClick: () => {
        setData([]);
        form.resetFields();
      },
    },
  ];

  const rules = [
    {
      clave: [
        {
          pattern: /^[0-9]{8}$/,
          message: 'Ingrese una clave válida',
        },
      ],
    },
  ];

  const columns = [
    // {
    //   titleText: 'ID',
    //   dataIndex: 'id',
    //   key: 'id',
    //   width: 150,
    // },
    {
      titleText: 'Código',
      dataIndex: 'codigo',
      key: 'codigo',
      width: 300,
    },
    {
      titleText: 'Titulo',
      dataIndex: 'titulo',
      key: 'titulo',
      width: 300,
    },
    // {
    //   titleText: 'Clave',
    //   dataIndex: 'clave',
    //   key: 'clave',
    //   width: 300,
    // },
  ];

  return (
    <>
      <Modal
        width="90%"
        visible={visible}
        closable={false}
        footer={null}
        title={(
          <FormSubmitControls
            label="Búsqueda Avanzada de SCIAN"
            controls={controls}
            loading={loading}
          />
        )}
        onCancel={onCancel}
        maskClosable={!loading}
        keyboard={!loading}
        forceRender
        centered
      >
        <Spin tip="Cargando..." spinning={loading}>
          <Form
            form={form}
            layout="vertical"
            onFinish={handleSearch}
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="codigo"
                  label="Código"
                  rules={rules.clave}
                  hasFeedback
                >

                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={8}>
                <Form.Item
                  name="descripcion"
                  label="Descripción"
                  hasFeedback
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              {/* <Col
                xs={24}
                sm={24}
                md={8}
              >
                <Form.Item
                  name="subclase"
                  label="Titulo de subclase"
                  hasFeedback
                  rules={rules.clave}
                >

                  <Select dataSource={subClase} />
                </Form.Item>
              </Col> */}
            </Row>
            <Row gutter={[10, 5]} justify="end">
              <Col xs={24} sm={24} md={6} lg={4}>
                <Button block htmlType="submit">
                  <SearchOutlined />
                  Buscar
                </Button>
              </Col>
              <Col xs={24} sm={24} md={6} lg={4}>
                <Button
                  onClick={add}
                  block
                  disabled={!selectedRowKeys.length}
                >
                  <PlusOutlined />
                  Cargar
                </Button>
              </Col>
            </Row>
          </Form>
          <Col span={24}>
            <Table
              cols={columns}
              data={data}
              noControls
              allowSort={false}
              allowSearch={false}
              rowSelection={rowSelection}
              onRow={(record) => ({
                onClick: () => {
                  setSelectedRowKeys([record.id]);
                },
                onDoubleClick: add,
              })}
              rowKey="id"
            />
          </Col>
        </Spin>
      </Modal>
    </>
  );
};

BusquedaAvanzadaSCIAN.propTypes = {
  callback: PropTypes.func.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
  dataExterno: PropTypes.arrayOf(PropTypes.shape()),
  setDataExterno: PropTypes.func,
};

BusquedaAvanzadaSCIAN.defaultProps = {
  dataExterno: [],
  setDataExterno: null,
};

export default BusquedaAvanzadaSCIAN;
